module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-6-26b05a1b.svg";